import CheckBox from './Checkbox';

export default CheckBox;
